import React, { FC, useEffect, useRef } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { getCarriersListFetch } from 'src/resources/carriersList/reducer';
import { RootStoreType } from 'src/types/store';
import TableSimple from 'src/components/TableSimple';
import { TableColumnType } from 'src/types/table';
import useInView from 'src/utils/useInView';

const allColumns: TableColumnType[] = [
  { key: 'SHIPPER', label: 'shipper', type: 'select', selectOption: 'shipperCodes', defaultShow: true },
  { key: 'COT', label: 'cot', defaultShow: true },
];

interface CarriersContainerProps {
  mobile?: boolean;
}

const CarriersContainer: FC<CarriersContainerProps> = () => {
  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const inView = useInView(containerRef, { rootMargin: '100px' });

  const loading = useSelector((state: RootStoreType) => state.carriersList.loading);
  const carriersData = useSelector((state: RootStoreType) => state.carriersList.data) || [];
  const shipperCodes = useSelector((state: RootStoreType) =>
    [...state.constantsCodes.data.shipperCodes].sort((a, b) => a.label.localeCompare(b.label))
  );

  useEffect(() => {
    if (inView) {
      dispatch(getCarriersListFetch());
    }
  }, [inView, dispatch]);

  return (
    <div ref={containerRef} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: 500 }}>
        {translate('carriers.title')}
      </h3>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <TableSimple
          rowIdKey="ID"
          rows={carriersData}
          loading={loading || !inView}
          columsLabelPrefix="carriers.table"
          allColumns={allColumns}
          initSort={{ column: 'SHIPPER', direction: 'ASC' }}
          selectOptions={{ shipperCodes }}
          showInModal
        />
      </div>
    </div>
  );
};

export default CarriersContainer;
